import { fadeIn, fadeOut } from "../utils/fade"

const monthlyPriceWrap = document.querySelectorAll(".monthly-price")
const annualPriceWrap = document.querySelectorAll(".annual-price")
const lisenceTextAnnual = document.querySelectorAll(".annual_lisence")
const lisenceTextMonthly = document.querySelectorAll(".monthly_lisence")
const discount = document.querySelectorAll(".save-descr")

export class initPaymnetToggle {
  constructor() {
    this.page_init()
    this.paymentTogglePlan()
  }

  paymentTogglePlan() {
    const paymentToggler = document.querySelectorAll(".payment_toggler")
    const planText = document.querySelectorAll(".active_toggler .plan_text")

    if (!paymentToggler) {
      return
    }
    paymentToggler.forEach((toggler) => {
      toggler.addEventListener("click", () => {
        toggler.classList.toggle("toggle")

        planText.forEach((planText) => {
          planText.classList.toggle("current_plan")
        })

        this.toggle_process(toggler)
      })
    })
  }

  toggle_process(toggler) {
    if (toggler.classList.contains("toggle")) {
      // Show monthly prices and hide annual prices
      monthlyPriceWrap.forEach((wrap) => {
        // setTimeout(() => {
        fadeIn(
          wrap,
          300,
          () => {
            wrap.classList.add("current-price-wrap")
          },
          "flex",
        )
        // }, 300)
      })
      annualPriceWrap.forEach((wrap) => {
        fadeOut(wrap, 300, () => {
          wrap.classList.remove("current-price-wrap")
        })
      })
      document.querySelectorAll(".save-descr").forEach((item) => {
        item.classList.add("save-descr_hide")
      })
      discount.forEach((item) => {
        fadeOut(item, 300, () => {
          item.classList.remove("show-discount")
        })
      })
      lisenceTextAnnual.forEach((item) => {
        fadeOut(item, 300, () => {
          item.classList.remove("show-annual-lisence")
        })
      })
      lisenceTextMonthly.forEach((item) => {
        fadeIn(item, 300, () => {
          item.classList.add("show-monthly-lisence")
        })
      })
    } else {
      // Show annual prices and hide monthly prices
      annualPriceWrap.forEach((wrap) => {
        // setTimeout(() => {
        fadeIn(
          wrap,
          300,
          () => {
            wrap.classList.add("current-price-wrap")
          },
          "flex",
        )
        // }, 300)
      })
      monthlyPriceWrap.forEach((wrap) => {
        fadeOut(wrap, 300, () => {
          wrap.classList.remove("current-price-wrap")
        })
      })
      document.querySelectorAll(".save-descr").forEach((item) => {
        item.classList.remove("save-descr_hide")
      })
      discount.forEach((item) => {
        fadeIn(item, 300, () => {
          item.classList.add("show-discount")
        })
      })
      lisenceTextAnnual.forEach((item) => {
        fadeIn(item, 300, () => {
          item.classList.add("show-annual-lisence")
        })
      })
      lisenceTextMonthly.forEach((item) => {
        fadeOut(item, 300, () => {
          item.classList.remove("show-monthly-lisence")
        })
      })
    }
  }

  page_init() {
    const paymentToggler = document.querySelectorAll(".payment_toggler")

    paymentToggler.forEach((toggler) => {
      this.toggle_process(toggler)
    })
  }
}
